import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryConfigurationInheritedEffects } from './category-configuration-inherited.effects';
import { categoryConfigurationInheritedReducer } from './category-configuration-inherited.reducer';

export const provideCategoryConfigurationInheritedStore = () => [
  provideState('categoryConfigurationInherited', categoryConfigurationInheritedReducer),
  provideEffects([CategoryConfigurationInheritedEffects]),
];
